import type { Distributor } from "./Distributor";
import type { RetailerType } from "./Retailer";
import type { Credit } from "./Credit";

export enum InvoicesStatuses {
  OUTSTANDING = "outstanding",
  PAID = "paid",
  CREDITS = "credits",
}
export enum InvoiceTypes {
  INVOICE = "invoice",
  CREDIT = "credit",
}
export interface Counts {
  paid: number;
  unpaid: number;
}

export interface PaymentInstrumentType {
  id: number;
  default_instrument: boolean;
  instrument_type: string;
  nickname: string;
}

export interface InvoiceFees {
  ach_fee: string;
  credit_card_fee: string;
  dispute_fee: string;
  dispute_inquiry_fee: string;
}

export interface PaymentTransferTypeSmall {
  created_at: string;
  scheduled_for: string;
  distributor_id: number;
  idempotency_key?: string;
  source_merchant_id?: string;
  source_transfer_id?: string;
  amount: number;
  id: number;
  payment_invoice_id: number;
  retailer_id: number;
  status: string;
  transfer_type: string;
  fee_type: string;
  net_amount: number;
  payment_method?: PaymentInstrumentType;
  messages: {
    message: string;
  }[];
  credit_redemptions: {
    id: number;
    credit_invoice: {
      id: number;
      invoice_reference_id: number;
    };
    amount: number;
  }[];
}

export interface Invoice {
  id: number;
  external_id: string;
  distributor_id: number;
  retailer_id: number;
  order_id: number;
  invoice_reference_id: string;
  amount_due: string;
  original_amount_due: string;
  fees: number;
  tax: number;
  discounts: number;
  issue_date: string;
  due_date: string;
  created_at: string;
  updated_at: string;
  distributor?: Distributor;
  invoice_status_type?: string;
  days_overdue?: string | number; // allowing number while we refactor query to remove string type from show
  submitted_by_user_email?: string;
  payment_date_submitted?: string;
  payment_method?: PaymentInstrumentType;
  payment_methods?: PaymentInstrumentType[];
  retailer_user: any;
  order?: any;
  retailer?: any;
  sales_rep?: any;
  payment_made?: PaymentTransferTypeSmall;
  debit_paid?: PaymentTransferTypeSmall;
  fee_paid?: PaymentTransferTypeSmall;
  payment_transfers?: PaymentTransferTypeSmall[];
  settlement_id: number | null;
  cash_on_delivery: boolean;
  payment_scheduled_for?: string;
  credit_status?: string;
  line_items: PaymentInvoiceLineItem[];
  total_scheduled_payment?: string;
  entry_source: string;
  is_payable: boolean;
  is_read_only: boolean;
  is_payable_after_due_date: boolean;
  use_credit_by_default: boolean;
  payment_confirmation?: PaymentConfirmation;
  invoice_source_url: string;
}

export interface PaymentTransferType {
  created_at: string;
  distributor: Distributor;
  distributor_id: number;
  source_merchant_id: string;
  source_transfer_id: string;
  id: number;
  amount: number;
  net_amount: number;
  payment_invoice: Invoice;
  payment_invoice_id: number;
  retailer: RetailerType;
  retailer_id: number;
  payment_method: PaymentInstrumentType;
  status: string;
  settlement_status: string;
  transfer_type: string;
  updated_at: string;
  fee: number;
  date_settled: Date;
  credit_redemptions: Credit[];
  applied_credit_transfers: PaymentTransferType[];
  payment_confirmation?: {
    confirmation_code: string;
  };
  retailer_distributor: {
    account_number?: string;
  };
}

export interface PaymentInvoiceLineItem {
  id: number;
  payment_invoice_id: number;
  order_id: number;
  full_price: string;
  discount: string;
  unit_price: string;
  product_name: string;
  total_discount: string;
  product_id: string;
  num_units: number;
  volume: string;
  unit_of_measure?: string;
  invoice_charge_1: string;
  charge_type_1: string;
  invoice_charge_2: number;
  charge_type_2: string;
  invoice_charge_3: number;
  charge_type_3: string;
  invoice_charge_4: string;
  charge_type_4: string;
  invoice_charge_5: string;
  charge_type_5: string;
  entry_source: string;
  deposit: string;
  sku: string;
}

export interface PaymentConfirmation {
  id: number;
  confirmation_code: string;
  payment_invoice_id: number;
  credit_transfer_id: number;
  payment_transfer_id: number;
  created_at: string;
  updated_at: string;
}
